export const OptionVariants = {
  Regular: 'regular',
  Contact: 'contact',
  ContactGroup: 'contactGroup',
};
